import { MrbBaseViewStore } from "mrb/core";
import { MrbTabViewStore } from "mrb/components/tabs";
import AppReleaseViewStore from "./AppReleaseViewStore";
import BetaChannelViewStore from "./BetaChannelViewStore";

const BETA_CHANNEL_TAB_INDEX = 1;

class AppReleaseCenterViewStore extends MrbBaseViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore);
        this.routeStore = routeStore;

        const route = this.rootStore.routerStore.getCurrentRoute();
        this.title = route && route.data ? route.data.title : null;

        this.appReleaseViewStore = new AppReleaseViewStore(rootStore, { routeStore });
        this.betaChannelViewStore = new BetaChannelViewStore(rootStore, { routeStore });

        this.tabsStore = new MrbTabViewStore(this.rootStore, {
            actions: {
                onTabChange: (tabIndex) => {
                    if (tabIndex === BETA_CHANNEL_TAB_INDEX && !this.betaChannelViewStore.isInitialized) {
                        this.betaChannelViewStore.initialize();
                    }
                },
            },
        });
    }

    onInit() {
        return this.appReleaseViewStore.initialize();
    }

    onDestroy() {
        this.appReleaseViewStore.destroy();
        this.betaChannelViewStore.destroy();
    }
}

export default AppReleaseCenterViewStore;
